module.exports = __webpack_public_path__ + "img/ic_register.e713254a.png";